<template>
  <div v-if="dataFinishedLoading" class="workReportsProfessor">
    <div id="weekFilter">
      <div id="weekFilterText">{{ $t(localeConsts.filterByWeek) }}</div>

      <b-input id="weekBtn" v-model="week" type="number"></b-input>
    </div>

    <b-tabs active-nav-item-class="activeTab" content-class="mt-3" lazy>
      <b-tab
        v-for="student in students"
        :key="student.user.id"
        :title="student.user.first_name + ' ' + student.user.last_name"
        :title-link-class="'tab-title-class'"
      >
        <StudentProjectMembers :user-id="student.user.id" :week="week"></StudentProjectMembers>

        <h6 id="title">{{ $t(localeConsts.workReportsCommentTableTitle) }}</h6>

        <ProfessorComments :user-id="student.user.id" :week="week"></ProfessorComments>
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
import StudentProjectMembers from './WorkReportsStudentProjectMembers'
import ProfessorComments from './WorkReportsProfessorComments'

import { generalHelperMethodsMixin } from '../../../mixins/generalHelperMethodsMixin'
import { filtersMixin } from '../../../mixins/filtersMixin'

import { workReportsMixin } from '../WorkReportsMixin'
import mapGettersMixin from '../../../mixins/mapGettersMixin'
import { apiFetchMethodsMixin } from '../../../mixins/apiFetchMethodsMixin'

export default {
  name: 'WorkReportsProfessor',
  components: { StudentProjectMembers, ProfessorComments },
  mixins: [generalHelperMethodsMixin, filtersMixin, workReportsMixin, mapGettersMixin, apiFetchMethodsMixin],

  data() {
    return {
      localeConsts: {
        workReportsTitle: 'WORKREPORTS.TITLE',
        filterByWeek: 'WORKREPORTS.FILTER_BY_WEEK',
        workReportsCommentTableTitle: 'WORKREPORTS.COMMENTS_TABLE_TITLE'
      },

      week: this.$store.getters['authentication/getCurrentWeek'],

      students: [],

      dataFinishedLoading: false
    }
  },

  async created() {
    this.dataFinishedLoading = await this.loadData()
  },

  methods: {
    async loadData() {
      await this.fetchGroupMembers()
      this.filterUserRoleAttributionsByStudents(this.fetchedGroupMembers)
      return true
    }
  }
}
</script>

<style lang="scss">
$text-color: #8b69a9;
$tabs-border-color: #8c8c8c;
$tabs-background-color: #f0ecec;

.workReportsProfessor {
  width: 100%;
}

#title {
  color: $text-color;
}

/*tabs*/

.activeTab {
  font-weight: bold;
  background-color: $tabs-background-color !important;
}

.tab-title-class {
  color: $text-color !important;
  border-left: 1px solid $tabs-border-color !important;
}

/*filters*/

#weekFilter {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-bottom: 10px;
}

#weekFilterText {
  margin-right: 4em;
}

/*buttons styling*/

#weekBtn {
  width: 70px;
}
</style>
